import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import caciLogoWhite from '../images/cacilogoWhite.png';
import './Pages.css';

export default function Home()
{
	localStorage.setItem('activeLinkIndex', '0');

	const navigate = useNavigate();
	const rightArrowRef = useRef(null);

	return (
		<>
		<div className='heroArea'>
			<img alt='CACI logo' className='homePageLogo' src={caciLogoWhite} />
			<Container>
				<Row style={{marginTop: '75px'}}>
					<Col md={12} className='text-end pe-3 pel-lg-5 mt-2 mt-lg-5'>
						<h1><span className='homeHeader1'>FY 2025 Corporate Responsibility Report</span><br/>
						<div data-aos='fade-in' data-aos-duration='1500' data-aos-delay='2250' data-aos-once='true'>
						<span className='homeHeader2'>Accountability<br/>where it counts</span>
						</div>
						</h1>
					</Col>
				</Row>
			</Container>
		</div>
		<div className='navigationArrows'>
			<div ref={rightArrowRef} className='arrowContainer rightArrow'
				onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
		        onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }}
				 onClick={() => {
              navigate('/president-and-ceo-message');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
              	    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
              	    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[1].classList.add('active');
              document.getElementsByClassName('underline')[1].classList.add('active');
            }}>
				<FontAwesomeIcon icon={faArrowRight} />
			</div>
		</div>
		</>
	);
}